import "../scss/policyDetails.scss";

const LeavePageConfirmationModal = (props) => {
  const {closeModal, confirmPageLeave} = props
  return (
    <div id="custom-modal" className="custom-modal">
      <div className="custom-modal-content">
        <div className="custom-modal-header d-flex justify-content-between align-items-center">
          <h4 className="ms-5 ps-5">Exit Confirmation</h4>
          <span onClick={() => {
            closeModal()
          }} className="custom-close" style={{ marginTop: "-50px", marginRight: "-15px" }}>&times;</span>
        </div>
        <div className="custom-modal-body text-center">
          <p>Are you sure you want to leave this page?</p>
        </div>
        <div className="custom-modal-footer">
          <button className="custom-btn custom-btn-secondary" onClick={() => {
            confirmPageLeave()
          }}>Yes</button>
          <button className="custom-btn custom-btn-primary" onClick={() => {
            closeModal()
          }}>No</button>
        </div>
      </div>
    </div>
  )
}

export default LeavePageConfirmationModal